import { api } from "../utils/api";
import type { StoreId } from "@KassaroAB/shared/types/ids";

export const generateBarcodeApi = (
  storeId: StoreId,
): Promise<{ barcode: string }> => {
  return api.post(`stores/${storeId}/barcodes/generate`, {});
};
